import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';
import { IntegrityMonitorCustomRuleGzDataProvider } from '../dataProvider/IntegrityMonitorCustomRuleGzDataProvider';

export class IntegrityMonitorCustomRuleFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorCustomRuleGzDataProvider);
  }
}
